import React, { useEffect, useRef, useState } from 'react';

import SlidingNavigationBar from '../../Components/Shared/SlidingNavigationBar/SlidingNavigationBar';
import SlidingNavigationBar1 from '../../Components/Shared/SlidingNavigationBar/SlidingNavigationBar1';
import SlidingNavigationBar2 from '../../Components/Shared/SlidingNavigationBar/SlidingNavigationBar2';
import SlidingNavigationBar3 from '../../Components/Shared/SlidingNavigationBar/SlidingNavigationBar3';

import CustomMarquee from '../../Components/PagesComponents/Home/CustomMarquee/CustomMarquee';
import Banner from '../../Components/Shared/Banner/Banner';
import { useStatics } from '../../hooks/useStatics';
import LeftSideBar from '../../Components/Shared/LeftSideBar/LeftSideBar';
import { homeLeftData, navbarData } from '../../Data/HomePageData';

import HomeCard from '../../Components/Shared/CustomCards/HomeCard/HomeCard';
import HomeCard1 from '../../Components/Shared/CustomCards/HomeCard/HomeCard1';

import { useThemeColor } from '../../hooks/useThemeColor';
import { useSliderCardMenu } from '../../hooks/useSliderCardMenu';

import InstallationPopup from './InstallationPopup';
import Swal from 'sweetalert2';
import { createPortal } from "react-dom";
import withReactContent from 'sweetalert2-react-content';

import { useGameItems } from '../../hooks/useGameItems';
import GameCard from '../../Components/Shared/CustomCards/GameCard/GameCard';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { useBonusBanner } from '../../hooks/useBonusBanner';
import BonusModal from './BonusModal';
// import DraggableSocials from '../../Components/Shared/MovableSocial/DraggableSocials';

// const MovableSocial = React.lazy(() => import('../../Components/Shared/MovableSocial/MovableSocial'));
// const MovableSocialWeb = React.lazy(() => import('../../Components/Shared/MovableSocial/MovableSocialWeb'));
const Footer = React.lazy(() => import('../../Components/Shared/Footer/Footer'));
// const InstallationPopup = React.lazy(() => import('./InstallationPopup'));

const Home = ({ installableBtnRef }) => {
    const ref = useRef(null);

    const { bonusBanner } = useBonusBanner();
    const { homeBannersList } = useStatics();
    const { sliderCardMenuData } = useSliderCardMenu();
    const [selectedLeftBarData, setSelectedLeftBarData] = useState(homeLeftData[0]);
    const [popUp, setPopUp] = useState(null);
    const [bonusModal, setBonusModal] = useState(null);

    // exclusive Game Data (first element only)
    // const currentGameData = sliderCardMenuData?.filter((filteredItem) => (filteredItem?.page?.name === sliderImgList?.[0]?.page_list_id?.name));
    const currentGameData = [sliderCardMenuData?.[0]]; // make it array

    // games
    const gameType = ((currentGameData?.[0])?.game_type_code) || null;
    const { allGames } = useGameItems(gameType);

    // console.log(sliderCardMenuData, currentGameData, allGames);

    // Extract the providers arrays and flatten them into a single array
    const allProviders = sliderCardMenuData?.flatMap(obj => obj?.game_provider);

    // Create a Map to store unique providers based on owner
    const uniqueProvidersMap = new Map();

    // Iterate over each providers object and add it to the Map if the provider_name is not already present
    allProviders?.forEach(provider => {
        if (!uniqueProvidersMap.has(provider?.provider_code)) {
            uniqueProvidersMap.set(provider?.provider_code, provider);
        }
    });

    // Convert the Map values back to an array
    const uniqueProvidersArray = Array.from(uniqueProvidersMap.values());

    // console.log(uniqueProvidersArray);

    // console.log(homeBannersList);

    const { colorMode } = useThemeColor();

    const announceDark = process.env.PUBLIC_URL + "/Assets/Images/Icons/MarqueeIcons/announcement-dark.svg";
    const announceLight = process.env.PUBLIC_URL + "/Assets/Images/Icons/MarqueeIcons/announcement-light.svg";

    const crossIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/SharedIcons/cross-icon.svg";

    // const appInstall = process.env.PUBLIC_URL + "/Assets/Images/statics/appInstall.svg";

    const MySwal = withReactContent(Swal);

    const requestForInstallApp = () => {
        if (installableBtnRef.current) {
            installableBtnRef.current.prompt();

            (installableBtnRef.current.userChoice).then((choiceResult) => { // install button function
                // console.log(choiceResult);
                if (choiceResult.outcome === "accepted") {
                    console.log("User accepted the A2HS prompt");
                    installableBtnRef.current = null;
                } else {
                    console.log("User dismissed the A2HS prompt");
                    alert("User dismissed installation");
                }
            });
        } else {
            return;
        }
    }

    const openPopUpModal = () => {

        setPopUp({
            visible: true,
        });
        setBonusModal(true);
    }

    const closePopUpModal = () => {
        setPopUp({
            visible: false,
        });
        // setBonusModal(false);
    }

    const showOfferDetailsSweetAlert2 = () => {
        MySwal.fire({
            icon: false,
            // iconHtml: `<img src=${appInstall} alt="appInstall" />`,
            showConfirmButton: false,
            background:
                colorMode === "dark"
                    ? "hsla(0,0%,100%,0.8)"
                    : colorMode === "light"
                        ? "hsla(0,0%,100%,0.8)"
                        : "var(--red)",
            color:
                colorMode === "dark"
                    ? "var(--white)"
                    : colorMode === "light"
                        ? "var(--dark)"
                        : "var(--red)",
            showCloseButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            // closeButtonHtml: "&times;",
            closeButtonHtml: `<img src=${crossIcon} alt="close" class="custom-close-icon" />`,
            customClass: {
                popup: "swal2-bottom-popup",
                closeButton: "custom-close-button",
            },
            willOpen: (el) => {
                el.style.animation = "slideInFromBottom 0.6s ease-out forwards";
            },
            willClose: (el) => {
                return new Promise((resolve) => {
                    el.style.animation = "slideOutToBottom 0.6s ease-in forwards";
                    setTimeout(resolve, 600); // match exit duration
                });
            },
            didOpen: () => openPopUpModal(),
            didClose: () => closePopUpModal(),
        });
    };

    useEffect(() => {
        // Check if it's the first load by inspecting sessionStorage
        const isFirstLoad = sessionStorage.getItem("isFirstLoad");

        // console.log(installableBtnRef?.current !== undefined, popUp);

        if ((installableBtnRef?.current !== undefined) && (!isFirstLoad)) {
            showOfferDetailsSweetAlert2();

            sessionStorage.setItem("isFirstLoad", "true");
        } else {
            closePopUpModal();
        }
        // Cleanup function to clear the sessionStorage flag on component unmount
        // return () => {
        //     sessionStorage.removeItem("isFirstLoad");
        // };
    }, [installableBtnRef?.current]);

    const [staticChangableData, setStaticChangebleData] = useState();

    const getData = () => {
        fetch("/changables/data.json"
            , {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Cache-Control": "no-store", // Disable cache
                },
                cache: "no-store", // Prevent browser from caching
            }
        )
            .then((response) => {
                // console.log(response)
                return response.json();
            })
            .then((data) => {
                // console.log(data);
                setStaticChangebleData(data);
            });
    };

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        const section = document.querySelector(".centered-main-section");

        if (section) {
            if (bonusModal && bonusBanner?.length) {
                section.classList.add("overflow-hidden");
            } else {
                section.classList.remove("overflow-hidden");
            }
        }
    }, [bonusModal, bonusBanner?.length]);

    return (
        <>

            {/* <DraggableSocials /> */}
            <Banner banner={homeBannersList} />
            <div style={{
                position: 'relative',
                height: '30px',
            }}>
                <button className='d-flex align-items-center justify-content-center announcement-icon themed-announcement-icon'>
                    <img src={(colorMode === "light") ? announceLight : announceDark} alt="announce" />
                </button>

                <div style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 9,
                }}>
                    <CustomMarquee />
                </div>
            </div>

            <div className="d-flex justify-content-start align-items-center mx-2 mt-0 mb-1 position-relative" style={{ backgroundColor: (colorMode === "light") ? "transparent" : (colorMode === "dark") ? "transparent" : "transparent", }}>
                {
                    (staticChangableData?.theme_type === "theme0") ?
                        <SlidingNavigationBar pageName={"Sports Exchange"} navbarData={navbarData} sliderData={sliderCardMenuData}
                            ref={ref}
                        />
                        :
                        (staticChangableData?.theme_type === "theme1") ?
                            <SlidingNavigationBar1 pageName={"Sports Exchange"} navbarData={navbarData} sliderData={sliderCardMenuData}
                                ref={ref}
                            />
                            :
                            (staticChangableData?.theme_type === "theme2") ?
                                <SlidingNavigationBar2 pageName={"Sports Exchange"} navbarData={navbarData} sliderData={sliderCardMenuData}
                                    ref={ref}
                                />
                                :
                                (staticChangableData?.theme_type === "theme3") ?
                                    <SlidingNavigationBar3 pageName={"Sports Exchange"} navbarData={navbarData} sliderData={sliderCardMenuData}
                                        ref={ref}
                                    />
                                    :
                                    <div></div>
                }
            </div>
            <div className="row gx-0 mx-2">
                <aside className="col-2"
                // style={{ border: "1px solid orange", }}
                >
                    {/* {"Side Bar"} */}
                    <LeftSideBar selectedLeftBarData={selectedLeftBarData} setSelectedLeftBarData={setSelectedLeftBarData} leftSideBarData={homeLeftData} />
                </aside>
                <div className="col-10"
                // style={{ border: "1px solid green", }}
                >
                    {/* {"Games or Content"} */}
                    {
                        (staticChangableData?.theme_type === "theme0") ?
                            <HomeCard cardData={sliderCardMenuData} />
                            :
                            (staticChangableData?.theme_type === "theme1") ?
                                <HomeCard1 cardData={sliderCardMenuData} />
                                :
                                ((staticChangableData?.theme_type === "theme2") || (staticChangableData?.theme_type === "theme3")) ? (
                                    <div className="pt-0">
                                        {
                                            allGames?.length > 0 ? (
                                                <GameCard
                                                    count={3}
                                                    gameCardData={allGames} // Adjust slicing if needed
                                                />
                                            ) : (
                                                // Render skeleton loaders when data is not available
                                                <div className="mx-2 row g-2">
                                                    {[...Array(9)].map((_, index) => (
                                                        <div key={index} className="col-4">
                                                            <div className="skeleton-card pb-2">
                                                                <Skeleton
                                                                    height={120}
                                                                    baseColor={(colorMode === "dark") ? "var(--dark)" : "var(--gray)"}
                                                                    highlightColor={(colorMode === "dark") ? "var(--gray)" : "var(--light-blue)"}
                                                                />
                                                                <Skeleton
                                                                    height={20}
                                                                    width="80%"
                                                                    baseColor={(colorMode === "dark") ? "var(--dark)" : "var(--gray)"}
                                                                    highlightColor={(colorMode === "dark") ? "var(--gray)" : "var(--light-blue)"}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )
                                        }
                                    </div>
                                )
                                    :
                                    <div></div>
                    }
                </div>
            </div>
            <footer>
                <Footer installableBtnRef={installableBtnRef} providersList={uniqueProvidersArray} />
            </footer>
            {/* {
                window.innerWidth >= 769
                    ?
                    <MovableSocialWeb />
                    :
                    <MovableSocial />
            } */}

            {
                (popUp?.visible)
                &&
                createPortal(
                    <InstallationPopup close={closePopUpModal} requestForInstallApp={requestForInstallApp} />,
                    Swal.getHtmlContainer() || document.body
                )
            }
            {
                (bonusModal && bonusBanner?.length) ? (
                    <BonusModal bonusBanner={bonusBanner} onClose={() => setBonusModal(false)} />
                ) : (<></>)
            }
        </>
    );
};

export default Home;